import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ButtonBase from '@/design-system/atoms/buttons/ButtonBase.vue'
interface EMITS {
  (e: 'onClicked')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonOutline',
  props: {
    buttonText: { default: '' },
    disabled: { type: Boolean, default: false },
    iconLeft: { default: '' },
    iconRight: { default: '' },
    size: { default: 'medium' }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

function onClicked() {
  if (!props.disabled) {
    emits('onClicked')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonBase, {
    class: _normalizeClass({ 'button-outline': !_ctx.disabled, small: _ctx.size === 'extra-small' || _ctx.size === 'small' }),
    buttonText: _ctx.buttonText,
    disabled: _ctx.disabled,
    iconLeft: _ctx.iconLeft,
    iconRight: _ctx.iconRight,
    size: _ctx.size,
    onOnClicked: onClicked
  }, {
    left: _withCtx(() => [
      _renderSlot(_ctx.$slots, "left")
    ]),
    right: _withCtx(() => [
      _renderSlot(_ctx.$slots, "right")
    ]),
    _: 3
  }, 8, ["class", "buttonText", "disabled", "iconLeft", "iconRight", "size"]))
}
}

})